import { render, staticRenderFns } from "./VBrokerListItem.vue?vue&type=template&id=4679d568"
import script from "./VBrokerListItem.vue?vue&type=script&lang=js"
export * from "./VBrokerListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports